export default "assets/images/map_mobile-4627fec9.png";